import { forwardRef } from 'react'
import { Label } from '../Typography'
import PropTypes from 'prop-types'

const Select = forwardRef(
  (
    { value, label, error, name, options, required, onChange = () => {} },
    ref
  ) => {
    const borderClass = error ? 'border-red-500 ' : ' border-gray-300 '

    const onSelect = (e) => {
      const index = e.nativeEvent.target.selectedIndex
      const label = e.nativeEvent.target[index].text
      const value = e.target.value
      onChange({ label, value }, name)
    }

    return (
      <div className="relative">
        {label && (
          <div className="mb-2">
            <Label small>{label}</Label>
          </div>
        )}
        <select
          ref={ref}
          name={name}
          value={value}
          required={required}
          className={`flex w-full truncate rounded py-3 ${borderClass}`}
          onChange={onSelect}
        >
          {options.map(({ label, value }) =>
            value !== null ? (
              <option key={label} value={value}>
                {label}
              </option>
            ) : (
              <option key={label}>{label}</option>
            )
          )}
        </select>
      </div>
    )
  }
)

// Display name
Select.displayName = 'Select box'

// Define prop types
Select.propTypes = {
  value: PropTypes.string,
  label: PropTypes.string,
  error: PropTypes.string,
  name: PropTypes.string,
  options: PropTypes.array,
  required: PropTypes.bool,
  onChange: PropTypes.func,
}

export default Select
